export const Footer: React.FC = () => (
  <footer className="bg-[#0A2342] text-white py-6 mt-16">
    <div className="container mx-auto text-center text-sm">&copy; {new Date().getFullYear()} Haifa Defence Academy · All rights reserved.</div>
  </footer>
);
